// see `docs/features.md` for more human-friendly features list
export const DEBUG_FEATURE = Symbol('DEBUG_FEATURE');
export const EDITOR_FEATURE = {
    accessibility: 'accessibility',
    addPanel: 'addPanel',
    addSectionPanel: 'addSectionPanel',
    appMarket: 'appMarket',
    privateApps: 'privateApps',
    comments: 'comments',
    component: 'component',
    contentManager: 'contentManager',
    duplicateApp: 'duplicateApp',
    editorTour: 'editorTour',
    layersPanel: 'layersPanel',
    menuManager: 'menuManager',
    pagesPanel: 'pagesPanel',
    renameApp: 'renameApp',
    rolesAndPermissions: 'rolesAndPermissions',
    search: 'search',
    siteCheckPanel: 'siteCheckPanel',
    themePanel: 'themePanel',
    upgrade: 'upgrade',
    viewport: 'viewport',
    inspectorPanel: 'inspectorPanel',
    contentEditingMode: 'contentEditingMode',
    widgetPanel: 'widgetPanel',
    dashboardPanel: 'dashboardPanel',
    photoStudio: 'photoStudio',
    multilingual: 'multilingual',
    addPlugin: 'addPlugin',
    myBusiness: 'myBusiness',
    [DEBUG_FEATURE]: DEBUG_FEATURE,
};
export const APPLICATION_FEATURE = {
// TODO
};
export const FEATURE = {
    ...EDITOR_FEATURE,
    ...APPLICATION_FEATURE,
};
export const FEATURE_PARAMS = {
    [FEATURE.accessibility]: [],
    [FEATURE.addPanel]: ['appDefinitionId', 'componentType'],
    [FEATURE.addSectionPanel]: [],
    [FEATURE.appMarket]: ['appDefinitionId'],
    [FEATURE.privateApps]: ['appDefinitionId', 'version'],
    [FEATURE.comments]: ['pageId', 'commentId'],
    [FEATURE.component]: ['id', 'panelName'],
    [FEATURE.contentManager]: ['tab'],
    [FEATURE.duplicateApp]: [],
    [FEATURE.editorTour]: ['tourName'],
    [FEATURE.layersPanel]: [],
    [FEATURE.menuManager]: [],
    [FEATURE.pagesPanel]: ['appDefinitionId'],
    [FEATURE.renameApp]: [],
    [FEATURE.rolesAndPermissions]: [],
    [FEATURE.search]: [],
    [FEATURE.siteCheckPanel]: [],
    [FEATURE.themePanel]: [],
    [FEATURE.upgrade]: [],
    [FEATURE.viewport]: ['size'],
    [FEATURE.inspectorPanel]: ['category'],
    [FEATURE.contentEditingMode]: ['contentEditingMode'],
    [FEATURE.widgetPanel]: ['devCenterComponentId'],
    [FEATURE.dashboardPanel]: ['devCenterComponentId'],
    [FEATURE.photoStudio]: ['mode', 'file'],
    [FEATURE.multilingual]: ['languageCode'],
    [FEATURE.addPlugin]: [],
    [FEATURE.myBusiness]: ['appDefinitionId'],
    [DEBUG_FEATURE]: ['arg0', 'arg1', 'arg2'],
};
export const FEATURE_REQUIRED_PARAMS = {
    [FEATURE.viewport]: ['size'],
    [FEATURE.component]: ['id'],
    [FEATURE.privateApps]: ['appDefinitionId'],
    [FEATURE.multilingual]: ['languageCode'],
};
export const FEATURE_PARAM_VALUES = {
    [FEATURE.viewport]: {
        size: ['phone', 'tablet', 'desktop'],
    },
    [FEATURE.contentManager]: {
        tab: ['collections', 'elements', 'learn'],
    },
    [FEATURE.component]: {
        // based on https://github.com/wix-private/santa-editor/blob/406be79a31216370ffb07184fb3e40dc56bd757a/santa-editor/packages/constants/base/baseConstants.ts#L452-L470
        panelName: [
            'animation',
            'apply',
            'background',
            'behaviors',
            // 'customizeDesign', // 'design' might be enough
            'design',
            'effects',
            'filters',
            'layout',
            'link',
            'manage',
            'mask',
            // 'mobileBackgroundSettings', // 'background' might be enough
            'settings',
            'smartWriter',
            'stretching',
            'stylable',
        ],
    },
};
// exported to keep backwards compatability. remove if/when bumping major version
export const VIEWPORT_SIZE_VALUES = FEATURE_PARAM_VALUES[FEATURE.viewport].size;
export const CONTENT_MANAGER_TABS = FEATURE_PARAM_VALUES[FEATURE.contentManager].tab;
function featureHasRequiredParams(type) {
    return type in FEATURE_REQUIRED_PARAMS;
}
function featureHasLimitedParams(type) {
    return type in FEATURE_PARAM_VALUES;
}
export function areParamsValid(type, params) {
    if (featureHasRequiredParams(type)) {
        const requiredParams = FEATURE_REQUIRED_PARAMS[type];
        if (params.length < requiredParams.length) {
            return false;
        }
        if (requiredParams.some((name, i) => !params[i])) {
            return false;
        }
    }
    if (featureHasLimitedParams(type)) {
        const paramsWithLimitedValues = FEATURE_PARAM_VALUES[type];
        const paramNames = FEATURE_PARAMS[type];
        const hasInvalidValue = params.some((value, i) => {
            const name = paramNames[i];
            if (name && name in paramsWithLimitedValues) {
                const possibleValues = paramsWithLimitedValues[name];
                if (possibleValues.indexOf(value) === -1) {
                    return true;
                }
            }
            return false;
        });
        if (hasInvalidValue) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=feature.js.map